import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Container, Paper } from "@mui/material";
import {
  ConditionalRenderer,
  Header,
  SuccessCreation,
} from "../../../components";
import { PracticeEditor } from "../../../features";
import { PracticeInputData } from "../../../@lib/types";

import { useMutation, gql } from "@apollo/client";
import { useNotify } from "../../../components/@common/NotificationsProvider";
import { useAuthSession } from "../../../components/AuthSessionProvider";

const createPracticeMutationDocument = gql`
  mutation CreatePracticeMutation($practiceInput: PracticeCreateInput!) {
    practiceCreate(input: $practiceInput) {
      practice {
        id
      }
    }
  }
`;

const PracticeNew = ({
  isNotPolicyCreateModified = true,
  onClosePopup = () => {},
  refetchFormOptions = () => {},
}: any) => {
  const [documentAttachmentDetails, setDocumentAttachmentDetails] =
    useState<any>(null);
  const [imageAttachmentDetails, setImageAttachmentDetails] =
    useState<any>(null);
  const [selectedListPolicies, setSelectedListPolicies] = useState<any>([]);
  const [selectedListPeople, setSelectedListPeople] = useState<any>([]);
  const [isOpen, setIsOpen] = useState({
    status: false,
    currId: null,
    module: "",
  });

  const location = useLocation();
  const notify = useNotify();
  const navigate = useNavigate();
  const { user } = useAuthSession() as any;

  const isAdmin = location?.pathname?.includes("admin");

  const [createPractice, { loading }] = useMutation(
    createPracticeMutationDocument,
    {
      context: {
        headers: {
          "access-token": user?.accessToken,
          client: user?.client,
          uid: user?.email,
        },
      },
    }
  );

  /**
   * handleFinish()
   */

  const listOfPoliciesIDs = selectedListPolicies?.map(
    (item: { value: string }) => Number(item?.value)
  );

  const listOfPeopleIDs = selectedListPeople?.map((item: { value: string }) =>
    Number(item?.value)
  );

  const handleFinish = useCallback(
    async (data: PracticeInputData) => {
      try {
        const response = await createPractice({
          variables: {
            practiceInput: {
              practiceInput: {
                ...data,
                policies: listOfPoliciesIDs,
                people: listOfPeopleIDs,
                ...(imageAttachmentDetails !== null
                  ? {
                      picture: {
                        source: imageAttachmentDetails?.base64URL,
                        originalFilename: imageAttachmentDetails?.name,
                      },
                    }
                  : {}),
                ...(documentAttachmentDetails !== null
                  ? {
                      document: {
                        source: documentAttachmentDetails?.base64URL,
                        originalFilename: documentAttachmentDetails?.name,
                      },
                    }
                  : {}),
              },
            },
          },
        });

        if (!isNotPolicyCreateModified) {
          onClosePopup();
          refetchFormOptions();
        } else {
          // navigate(`/${currentModule}/practices`);
          setIsOpen({
            status: true,
            currId: response?.data?.practiceCreate?.practice?.id,
            module: "success",
          });
        }

        return;
      } catch (err) {
        notify.error(err as Error);
      }
    },
    [
      createPractice,
      navigate,
      notify,
      imageAttachmentDetails,
      documentAttachmentDetails,
      listOfPoliciesIDs,
      listOfPeopleIDs,
    ]
  );

  /**
   * handleCancel
   */
  const handleCancel = useCallback(() => {
    !isNotPolicyCreateModified ? onClosePopup() : navigate(-1);
  }, [navigate]);

  return (
    <Box mb={!isNotPolicyCreateModified ? 0 : 24}>
      <SuccessCreation
        isOpen={isOpen}
        newCreationPath="/submission/practices/new"
        viewPath={isAdmin ? `/admin/practices/` : "/practices/"}
        module="Practice"
      />
      <ConditionalRenderer condition={isNotPolicyCreateModified}>
        <Header
          title="Create new practices"
          subtitle=""
        />
      </ConditionalRenderer>

      <Container sx={{ my: 3 }}>
        <Paper component={Container} sx={{ py: 3 }}>
          <PracticeEditor
            onCancel={handleCancel}
            onFinish={handleFinish}
            disabled={loading}
            isNotPolicyCreateModified={isNotPolicyCreateModified}
            imageAttachmentDetails={imageAttachmentDetails}
            documentAttachmentDetails={documentAttachmentDetails}
            setImageAttachmentDetails={setImageAttachmentDetails}
            setDocumentAttachmentDetails={setDocumentAttachmentDetails}
            setSelectedListPolicies={setSelectedListPolicies}
            selectedListPolicies={selectedListPolicies}
            setSelectedListPeople={setSelectedListPeople}
            selectedListPeople={selectedListPeople}
          />
        </Paper>
      </Container>
    </Box>
  );
};

export { PracticeNew };
